import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Button } from '@mui/material';
import useGlobal from '../util/Global';
import SysGlobalKeyservice from '../service/MasterServices/SysGlobalKeyService';
import useMessage from '../util/useMessage';
import { MessageType } from '../util/Enums';

const NoteDialog = ({ open, onClose, title, message, isGlobalSet = false, data = null }) => {

    const { g } = useGlobal();

    const [isCopied, setIsCopied] = useState(false);
    const [loading, setLoading] = useState(false);

    const showMessage = useMessage();

    useEffect(() => {
        setlocalMessage(message);
    }, [message]);

    // Function to copy the message to clipboard
    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(message).then(() => {
            setIsCopied(true);
        }).catch((err) => {
            console.error('Failed to copy text to clipboard:', err);
        });
    };

    const handelImportGlobal = () => {
        if (loclamessage) {
            setLoading(true);
            SysGlobalKeyservice.SyncGlobalUpdate(loclamessage).then((res) => {
                if (res.isSuccess) {
                    showMessage(g('message.created'));
                } else {
                    showMessage(g('message.updateFailed'), MessageType.ERROR);
                }

                setLoading(false);
            });


        }
    }

    const [loclamessage, setlocalMessage] = useState('');

    const handleMessageChange = (event) => {
        setlocalMessage(event.target.value); // Update the state when the input changes
    };

    return (
        <Dialog fullWidth
            maxWidth="lg"

            scroll="paper" open={open} onClose={onClose}>
            <DialogContent>
                <p>{title}</p>
                <TextField
                    fullWidth
                    variant="outlined"
                    value={loclamessage}
                    onChange={handleMessageChange}
                    multiline
                    rows={25}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between" }} >
                <div>
                    <Button onClick={handelImportGlobal} color="danger" disabled={loading}>
                        {g('button.import')}
                    </Button>
                </div>
                <div>
                    <Button onClick={handleCopyToClipboard} color={isCopied ? "secondary" : "primary"}>
                        {g('button.copy')}
                    </Button>
                    <Button onClick={onClose} color="primary">
                        {g('button.close')}
                    </Button>
                </div>
            </DialogActions>

        </Dialog>
    );
};

export default NoteDialog;
